// WHAT AN ASSET IS CALLED — PURE. THE ONE PLACE the "title, else the file name" choice is made.
//
// ⚠️ The grid, the headings and the confirmations show `assetDisplayName`; the Name SORT key is derived from the same
// source string (derived.ts takes `assetNameSource`, then lowercases and clamps it). Both come from THIS function, so a
// "Name" sort cannot order by a string the grid does not show. displayName.test.ts pins the agreement over the three cases
// that matter, including a whitespace-only title.
// ⚠️ A title that is empty or only whitespace is NO title: it falls back to the file name. (normalizeAssetTitle never
// stores one, but a stored whitespace title would otherwise render as a blank tile and sort as the empty string.)

export function assetNameSource(a: { title?: string | null; originalFilename: string }): string {
  const t = a.title?.trim();
  return t ? t : a.originalFilename.trim();
}

/** The name a tile, a heading, an alt text or a confirmation uses. */
export function assetDisplayName(a: { title?: string | null; originalFilename: string }): string {
  return assetNameSource(a);
}

/**
 * The line shown BENEATH a confirmation's title, so the file name stays visible next to the title: `Original file:
 * “DJI_0496.JPG”`. null for an untitled asset, whose title line already IS the file name.
 */
export function originalFileLine(a: { title?: string | null; originalFilename: string }): string | null {
  return assetNameSource(a) === a.originalFilename.trim() ? null : `Original file: “${a.originalFilename}”`;
}

/**
 * The name followed by the original file when they differ — for lines that cannot show the file name beneath
 * (a bulk failure list). `Drone Building Shot (DJI_0496.JPG)`; an untitled asset is just its file name.
 */
export function assetNameWithFile(a: { title?: string | null; originalFilename: string }): string {
  const name = assetNameSource(a);
  return name === a.originalFilename.trim() ? name : `${name} (${a.originalFilename})`;
}
